import { OverviewPeriod } from '@trace/types';
import { DateTime } from 'luxon';

/**
 * Takes a timestamp, and a selected OverviewPeriod into account, to generate a title to display for Overview chart
 * tooltips.
 *
 * @example
 * getTooltipTitle({timestamp}, 'monthly') => 'April'
 * getTooltipTitle({timestamp}, 'weekly') => 'April 04'
 * getTooltipTitle({timestamp}, 'daily') => 'Tuesday'
 *
 * @param timestamp
 * @param period
 */
const getTooltipTitle = (timestamp: number | null, period: OverviewPeriod): string => {
  if (timestamp === null) return '';

  const dateTime = DateTime.fromMillis(timestamp);

  switch (period) {
    case 'monthly':
      return dateTime.toLocaleString({ month: 'long' });
    case 'weekly':
      return dateTime.toLocaleString({ month: 'long', day: '2-digit' });
    case 'daily':
    default:
      return dateTime.toLocaleString({ weekday: 'long' });
  }
};

export default getTooltipTitle;
